module.exports = __webpack_public_path__ + "static/media/Spinner_US.f864a890.gif";